<template lang="pug">
  .new-user-promotion-email {{ email }}
</template>

<script>
export default {
  name: 'new-user-promotion-email',

  computed: {
    email() {
      return this.$parent.email;
    }
  }
}
</script>
